<button
	*ngIf="!useMenuButton"
	(click)="openRFPDialog()"
	[disabled]="
		isOnRecommendedTab ||
		IS_NULL_OR_UNDEFINED(projectDTO) ||
		numberOfCarriers == 0 ||
		isRFPRequestedToday()
	"
	color="primary"
	mat-raised-button
	matTooltip="Check Capacity has already been run for this project today."
	[matTooltipDisabled]="!isRFPRequestedToday()"
	matTooltipClass="custom-tooltip"
>
	<span [matTooltipShowDelay]="250" [matTooltip]="getTooltipMessage()">{{ buttonText }}</span>
</button>

<button
	*ngIf="useMenuButton"
	(click)="openRFPDialog()"
	[disabled]="
		isOnRecommendedTab ||
		IS_NULL_OR_UNDEFINED(projectDTO) ||
		numberOfCarriers == 0 ||
		isRFPRequestedToday()
	"
	color="primary"
	mat-menu-item
	matTooltip="Check Capacity has already been run for this project today."
	[matTooltipDisabled]="!isRFPRequestedToday()"
	matTooltipClass="custom-tooltip"
>
	{{ buttonText }}
</button>
